import cx from 'classnames'
import styles from './common.module.scss'

export const Skel = (props: { width?: string; height?: string; className?: string }) => (
  <div className={cx(styles.skeleton, props.className)} style={{ width: props.width, height: props.height }} />
)

export const AnchorOrDiv: React.FC<React.PropsWithChildren<{ className?: string; link?: string }>> = ({
  link,
  className,
  children,
}) => {
  return link ? (
    <a href={link} className={className} rel="noopener noreferrer" target="_blank">
      {children}
    </a>
  ) : (
    <div className={className}>{children}</div>
  )
}
